import React, { useState, useEffect } from "react";
import Preloader from "../../../components/Preloader/Preloader";
import { Redirect } from "react-router-dom"
import axios from "axios";
import {AddAlertRounded, CollectionsBookmarkOutlined, LoyaltyTwoTone } from "@material-ui/icons";
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { addDays, format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from '@material-ui/core/FormLabel';
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import ButtonComponent from 'react-button-component';
import LoadingOverlay from 'react-loading-overlay';
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";

import DynamicTable from "../../../components/DynamicTable";
import { DateRangePicker } from "materialui-daterange-picker";
const useStyles = makeStyles((theme) => ({
	btnSearch: {
        marginTop: 10,
        marginLeft: 15,
        backgroundColor: "green",
        marginRight:30
	},
    modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
    paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
}));
const ReceiveActivationCards = (props) => {

    const refDataFilter = React.useRef();
    const onFetchedApi = () => {
        refDataFilter.current.onFetchApi();
    };

    const [posts, setPosts] = useState([]);
    const toggle = () => setOpen3(!setOpen3);
    const classes = useStyles();

    const [nextPagePath, setNextPagePath] = useState("");
    const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
    const [userName, setUsername] = useState(get_cookies('username'));
    const [idnoselected, setIdnoSelected] = useState("");
    const [receiveBtn, showReceiveBtn] = useState(false);
    const [isLoaded, setisLoaded] = useState();
    const [selectedIDNO, setSelectedIDNO] = useState([]);
    const min_releasedate = '2021-04-01';
    const TransactionInformation = {};
    const [dateRange, setDateRange] = useState({
		startDate: new Date(),
		endDate: addDays(new Date(), 7),
	});

	const nextpage =  {
		// pathname: "/package-sales-payment",
		pathname: "/branch-package-purchase-firststep",
	}
    const nextpageEncoding =  {
        isCORelease:"yes"
	}
    const headers = {
        'Content-Type': 'multipart/form-data',
    };

    const dateRangeHandler = (range) => {
		setDateRange(range);
		setOpen3(false);
	};


	//ApiData Component useState SOF
    const activationcardshqlist = () => {
        setisLoaded(false);
		//get data for warehouse/location dropdown
		const form_data = {
			hqidno: branchIdNo,
            prep_data: prep_data
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'activationcardshqlist';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            loadActivationCardList(res.data);
		});
	};

	//ApiData Component useState EOF
	
	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

    //Loading overlay
    const [showOverlay, setShowOverlay] = useState(false);
    const [overLayMsg, setOverlayMsg] = useState(false);
    //Loading overlay EOF

	//Table Settings
	const [TABLE_DATA, loadDataTable] = useState([]);
    
	const loadActivationCardList = (data) => {
        refreshTable();
		const newData = [...TABLE_DATA];
        if(data.activationcardslist.length > 0){
            showReceiveBtn(true);
        }else{
            showReceiveBtn(false);
        }
		for (let i=0;i < data.activationcardslist.length;i++) {
            const tempObj = {
                    count:data.activationcardslist[i]['count'], 
                    trandate:data.activationcardslist[i]['date'], 
                    idno:data.activationcardslist[i]['idno']
                }
            newData.push(tempObj);
        }
		loadDataTable([...newData]);
        setisLoaded(true);
	};
    
	const refreshTable = () => {
        TABLE_DATA.length = 0;
        const newData = [...TABLE_DATA];
		loadDataTable([...newData]);
	}

	const columns = [
        {
            name: 'count',
            label: 'Count',
            options: {
				filter: false,
				sort: true,
				customBodyRender: (rowIndex, dataIndex) => dataIndex.rowIndex + 1 
			}
        },
		{
		  name: 'date',
		  label: 'Date',
		}, {
		  name: 'idno',
		  label: 'ID No.',
		}
	];
	
	const TABLE_OPTION = {
        selectableRows: 'multiple',
        filterType: 'checkbox',
        onRowsSelect : (curRowSelected, allRowsSelected) => {
            setSelectedIDNO(allRowsSelected);
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
            ""
        )
	};
	//Table Settings EOF

	//Modal Settings
	const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
    const handleOpen2 = () => {
		setOpen2(true);
	};
    const handleOpen3 = () => {
		setOpen3(true);
	};

	const handleClose = () => {
		setOpen(false);
	};
    const handleClose2 = () => {
		setOpen2(false);
	};
    const handleClose3 = () => {
		setOpen3(false);
	};
	//Modal Settings EOF
    const formatDate = (date) => {
		let d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

		if (month.length < 2) 
			month = '0' + month;
		if (day.length < 2) 
			day = '0' + day;

		return [year, month, day].join('-');
	}
    const proceedtoencoding = () => {
        props.history.push(nextpage);
    }

   

    //FormData
	const [prep_data, setData] = useState({"startDate":formatDate(new Date()),"endDate":formatDate(new Date())});
	//FormData EOF
	//OnLoad Event/Data Fetching SOF
	useEffect(() => {
        isLoggedIn();
        onFetchedApi();
    }, []);
    
    //OnLoad Event/Data Fetching SOF

    const receiveactivationcards = (idnoarray) => {
        setShowOverlay(true);
        setOverlayMsg('Receiving Activation Cards...');
		//get data for warehouse/location dropdown
		const form_data = {
            username: userName,
			idnoarray: idnoarray
		}
        const formData = new FormData();
        formData.append('form_data', JSON.stringify(form_data));
		const apiUrl = process.env.REACT_APP_API_URL+'receiveactivationcards';
		axios.post(apiUrl, formData, {headers:headers}).then((res) => {
            if(res.data.result.success == 1){
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("success");
                setTimeout(() => {
                    setShowOverlay(false);
                    setOverlayMsg('');
                    setShowMsgBox(false);
                }, 3000)
                // activationcardshqlist();
                onFetchedApi(); 

             
            }else{
                setShowMsgBox(true);
                setMsg(res.data.result.message);
                setMsgType("warning");
                setTimeout(() => {
                    setShowMsgBox(false);
                }, 3000)
            }
        }); 
	};

    const receiveActivationHandler = (tableState) => {
        const dataInTable = tableState.data;
        const selectedDataByIndex = tableState.selectedRows.data;
        setSelectedIDNO(selectedDataByIndex.map( row => dataInTable[row.index].data[2]));
    }

    const prep_selectedIDNO = () => {
        if(selectedIDNO.length > 0){
            receiveactivationcards(selectedIDNO);
        }else{
            setShowMsgBox(true);
            setMsg("Please select at least one idno to receive");
            setMsgType("warning");
            setTimeout(() => {
                setShowMsgBox(false);
            }, 3000)
        }
    }

    // Date Picker
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const startDateChanged = (e) => {
        setStartDate(e);
        const newData = {...prep_data};
        newData['startDate']= formatDate(e);
        setData({ ...newData });
    }
    const endDateChanged = (e) => {
        setEndDate(e);
        const newData = {...prep_data};
        newData['endDate']= formatDate(e);
        setData({ ...newData });
    }
    //Date Picker EOF
	return (
		<div className="page">
            <LoadingOverlay
                active={showOverlay}
                spinner
                text={overLayMsg}
            >
			<div className="page-header">
				<div className="page-icon">
					<ShoppingCartIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/sales">
						<h2 className="header-title">Sales</h2>
					</NavLink>
					<Typography color="textPrimary">Receive Activation Cards</Typography>
				</Breadcrumbs>
			</div>
            <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
			<div className="page-container">
                <MuiPickersUtilsProvider
                    utils={DateFnsUtils}
                >
                    <Grid container spacing={1}>
                            <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                                <TextField
                                    id="outlined-basic"
                                    label="Select Date"
                                    variant="outlined"
                                    onFocus={() => setOpen3(true)}
                                    fullWidth={true}
                                    autoComplete="off"
                                    value={`${format(
                                        dateRange.startDate,
                                        "MM/dd/yyyy"
                                    )} - ${format(dateRange.endDate, "MM/dd/yyyy")}`}
                                />
                                <DateRangePicker
                                    open={open3}
                                    toggle={toggle}
                                    onChange={(range) => dateRangeHandler(range)}
                                /> 
                            </Grid>
                            <Grid item xs={12} lg={6} xl={6}>
                                <Button variant="contained" style ={{marginTop: "10px"}} color="primary"  onClick={onFetchedApi}>Search</Button>
                                {
                                    (selectedIDNO.length > 0) ? 
                                    <Button 
                                    variant="contained" 
                                    color="primary"
                                    className={classes.btnSearch}
                                    onClick={(e) => {prep_selectedIDNO();}}
                                    >
                                    Receive Activation Cards
                                    </Button>
                                    :
                                    null      
                                }
                            </Grid>
                        </Grid> 
                </MuiPickersUtilsProvider>
                <Grid item xs={12} style={{marginTop: '15px'}}>
                { 
                    // !isLoaded ?  <Preloader /> :										
                    <DynamicTable
						title="Receive Activation Cards"
						columns={columns}
                        selectableRows="multiple"
						rows={posts}
						setRows={setPosts}
						ref={refDataFilter}
						dateRange = { dateRange }
						url='activationcardshqlist'
                        custom_function={{receiveActivationHandler}}
          			/>
                }
                </Grid>
			</div>
            </LoadingOverlay>
            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <div className={classes.paper}>
                            <h2 id="transition-modal-title">System Message</h2>
                            <form action="" className={classes.root}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        Are you sure you want to release this package?
                                    </Grid>
                                </Grid>
                                <div className={classes.button}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={2}>
                                        <Button
                                            variant="contained"
                                            onClick={handleClose}
                                            className={classes.buttonMarginRight}
                                        >
                                            No
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <Button 
                                            variant="contained" 
                                            color="primary" 
                                        >
                                            Yes
                                        </Button>
                                    </Grid>
                                    </Grid>
                                </div>
                            </form>
                        </div>
                    </Fade>
                </Modal>
            </div>
		</div>
	);
};

export default ReceiveActivationCards;
